import { GETACCOUNTRECHAGEDETAILS, GETRENEWSUBSCRIPTIONDETAIL, PAYMENT_CREATE_ORDER } from "../../utils/api"
import axios from "../../utils/axios"
import { Toast } from "../../utils/commonUtils";

export const getAccountReachageDetails = async () => {
    const res = await axios.get(GETACCOUNTRECHAGEDETAILS)
    return res;
}
export const getNewSubscriptionReachageDetails = async () => {
    const res = await axios.get(GETRENEWSUBSCRIPTIONDETAIL)
    return res;
}

// GETRENEWSUBSCRIPTIONDETAIL


export const PaymentCreateOrder = async (payload, callback) => {
    await axios
        .post(PAYMENT_CREATE_ORDER, payload)
        .then((res) => {
            console.log("res search ", res);
            // callback(res)
            callback(res?.data?.data);

            if (res?.data?.succeeded) {
                console.log("res search ", res?.data);
                // Toast.fire({
                //     icon: "success",
                //     title: "Update booked succesfully.",
                // });
            } else {
                Toast.fire({
                    icon: "error",
                    title: res?.data?.message,
                });
            }
        })
        .catch((err) => {
            console.log(err);
        });
};